<script>
export default {
  name: 'HubImageUploader',
  props: {
    value: {
      type: String,
      default: null,
    },
    crop: {
      type: String,
      default: '',
    },
    dimensionsMin: {
      type: Array,
      default: null,
    },
    sizeMax: {
      type: Number,
      default: 5000,
    },
  },
  methods: {
    onSuccessUploading(img) {
      // Backend doesn't allow URL without protocol prefix
      this.$emit('input', 'https:' + img.cdnUrl)
    },
  },
}
</script>

<template>
  <image-uploader
    :image="value"
    crop="1:1"
    :dimensions-min="dimensionsMin"
    :size-max="sizeMax"
    :class="$style.uploader"
    :clear="false"
    button-position="left"
    button-type="default"
    @onUpload="onSuccessUploading"
  >
    <template #button-text>
      <div :class="$style.uploadPlus">
        +
      </div> Select file
    </template>
    <template #preview="{ preview, size }">
      <div :class="$style.previewWrapper">
        <div :class="$style.previewImageWrapper">
          <img
            :src="preview"
            :class="$style.previewImage"
          >
        </div>
        <div :class="$style.previewInfo">
          <div>
            <a
              :href="`${ preview }`"
              target="_blank"
            >{{ preview }}</a>
          </div>
          <div :class="$style.previewSize">
            {{ size | fileSize }}
          </div>
        </div>
        <div :class="$style.previewCheck">
          <el-icon name="success" />
        </div>
      </div>
    </template>
  </image-uploader>
</template>

<style lang="scss" module>
.uploader {
  width: 100%;
}

.uploadPlus {
  display: inline-flex;
  margin-right: rem(4px);
  transform: scale(1.6);
}

.previewWrapper {
  position: relative;
  display: flex;
  padding: rem(20px);
  margin-top: rem(30px);
  border: 1px solid #DCDFE6;
  border-radius: rem(4px);
}

.previewImageWrapper {
  flex-shrink: 0;
  width: rem(70px);
  height: rem(70px);
  margin-right: rem(30px);
  overflow: hidden;
  border-radius: rem(10px);
  box-shadow: rem(0 2px 4px 0) rgba(0,0,0,0.20);
}

.previewImage {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.previewInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1;
}

.previewSize {
  margin-top: rem(4px);
  color: #8492a6;
}

.previewCheck {
  display: flex;
  align-items: center;
  margin-left: auto;
  font-size: rem(21px);
  color: #0fbd1c;
}
</style>
